export default "__VITE_PUBLIC_ASSET__6fa3452c__"